module.exports = __webpack_public_path__ + "media/assets/icons/speed-9780b2b4b3a1e94b9264402cf8203993.svg";